import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { CommandDialog, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem } from "@/components/ui/command";
import { Users, FileText, CalendarDays, SlidersHorizontal, Settings, User, Plus } from "lucide-react";

const PAGES = [
  ["/crm", "CRM", Users], ["/forms", "Forms", FileText], ["/calendar", "Calendar", CalendarDays],
  ["/crm/setup", "CRM setup", SlidersHorizontal], ["/settings", "Settings", Settings],
];

export default function CommandPalette({ open, setOpen }) {
  const nav = useNavigate();
  const [q, setQ] = useState("");
  const [leads, setLeads] = useState([]);
  const [forms, setForms] = useState([]);
  useEffect(() => {
    const onKey = (e) => { if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") { e.preventDefault(); setOpen((o) => !o); } };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [setOpen]);
  useEffect(() => { if (open) api.get("/forms").then((r) => setForms(r.data.rows)).catch(() => {}); }, [open]);
  useEffect(() => {
    if (!open) return undefined;
    const t = setTimeout(() => api.post("/crm/leads/query", { q: q || undefined, limit: 8, sort: { field: "updated_at", dir: "desc" } })
      .then((r) => setLeads(r.data.rows)).catch(() => {}), 150);
    return () => clearTimeout(t);
  }, [q, open]);
  const go = (to) => { setOpen(false); setQ(""); nav(to); };
  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput placeholder="Search leads, forms, pages…" value={q} onValueChange={setQ} data-testid="cmdk-input" />
      <CommandList data-testid="cmdk-list">
        <CommandEmpty>No results.</CommandEmpty>
        <CommandGroup heading="Leads">
          {leads.map((l) => (
            <CommandItem key={l._id} value={`lead ${l.name} ${l.email || ""} ${l.phone || ""} ${l._id}`} onSelect={() => go(`/crm?lead=${l._id}`)} data-testid={`cmdk-lead-${l._id}`}>
              <User size={14} className="mr-2" />{l.name}<span className="ml-2 text-xs text-neutral-500 truncate">{l.email || l.phone}</span><span className="ml-auto text-[10px] text-neutral-500">{l.stage}</span>
            </CommandItem>
          ))}
        </CommandGroup>
        <CommandGroup heading="Forms">
          {forms.map((f) => <CommandItem key={f._id} value={`form ${f.title} ${f.slug}`} onSelect={() => go(`/forms/${f._id}`)} data-testid={`cmdk-form-${f.slug}`}><FileText size={14} className="mr-2" />{f.title}</CommandItem>)}
        </CommandGroup>
        <CommandGroup heading="Go to">
          {PAGES.map(([to, l, I]) => <CommandItem key={to} value={`page ${l}`} onSelect={() => go(to)} data-testid={`cmdk-page-${l}`}><I size={14} className="mr-2" />{l}</CommandItem>)}
          <CommandItem value="new lead create" onSelect={() => go("/crm?new=1")} data-testid="cmdk-new-lead"><Plus size={14} className="mr-2" />New lead</CommandItem>
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}
